const validate = (value, { bik } = {}) => {
  let result = false
  if (!bik || !bik.length) { return false }
  if (typeof value === 'number') {
    value = value.toString()
  } else if (typeof value !== 'string') {
    value = ''
  }
  if (!!value.length && value.length === 20 && /[0-9]/.test(value)) {
    const bikKs = '0' + bik.toString().slice(4, 6) + value
    let checksum = 0
    const coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
    for (const i in coefficients) {
      checksum += coefficients[i] * (bikKs[i] % 10)
    }
    if (checksum % 10 === 0) {
      result = true
    }
  }

  return result
}

export default {
  validate,
  params: ['bik']
}
